/* eslint-disable*/
import React, { useEffect, useState } from 'react';

import { useMatch } from 'react-router-dom';
import api, { authHeader } from '../../../../../services/API/apiConfig';
import { CardStyled, TitleStyled } from './AppliedFilter.styles';

const filtersDisplay = {
  constructions: 'Obra',
  creation_date: 'Data de lançamento',
  due_date: 'Vencimento',
  date_range: 'Periodo de vencimento',
  last_payables: 'Últimos lançamentos',
  total: 'Valor',
  status: 'Status de pagamento',
  supplier: 'Fornecedor',
  category: 'Categoria',
  items: 'Itens de orçamento',
};

const AppliedFilterCard = ({ filter, handleRemoveFilter }) => {
  return (
    filter[1] && (
      <CardStyled>
        <span className="cardText">{filtersDisplay[filter[0]]}</span>
        <span className="cardBtn" onClick={() => handleRemoveFilter(filter)}>
          x
        </span>
      </CardStyled>
    )
  );
};

const AppliedFilters = ({ filter, getPayables }) => {
  const [appliedFilters, setAppliedFilters] = useState([]);
  let id = null;
  const match = useMatch('/constructions/:id');
  const matchClient = useMatch('/constructions-details/:id');

  if (match) {
    id = parseInt(match.params.id);
  } else if (matchClient) {
    id = parseInt(matchClient.params.id);
  }

  useEffect(() => {
    setAppliedFilters(
      Object.entries(filter).filter(
        (item) =>
          item[1] !== null &&
          item[0] !== 'id' &&
          item[0] !== 'user_id' &&
          item[0] !== 'construction_id'
      )
    );
  }, [filter]);

  const handleRemoveFilter = async (filterArr) => {
    setAppliedFilters((prevState) => {
      const newFilters = prevState.filter((item) => item[0] !== filterArr[0]);
      return newFilters;
    });

    const [key, value] = filterArr;

    const newFilter = {
      filter: {
        ...filter,
        [key]: null,
        id: null,
        user_id: null,
        construction_id: null,
      },
    };
    if (appliedFilters.length === 1) {
      setAppliedFilters([]);
      api
        .delete(`/filters/${filter.id}`, {
          headers: authHeader(),
        })
        .then((res) => {
          window.location.reload();
        });
      return;
    }
    if (id !== null) {
      await api
        .post(`constructions/${id}/filters`, newFilter, {
          headers: authHeader(),
        })
        .then((res) => {
          getPayables();
        })
        .catch((err) => console.log(err));
    } else {
      await api
        .post('/filters', newFilter, {
          headers: authHeader(),
        })
        .then((res) => {
          getPayables();
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <div>
      <TitleStyled variant="h2">Filtros aplicados:</TitleStyled>

      {appliedFilters.map((filter, index) => (
        <AppliedFilterCard
          filter={filter}
          key={index}
          setAppliedFilters={setAppliedFilters}
          appliedFilters={appliedFilters}
          handleRemoveFilter={handleRemoveFilter}
        />
      ))}
    </div>
  );
};

export default AppliedFilters;
